<template>
    <div>
        <div class="ap-modal-element">
            <div class="modal-grid-two-cols stripe stripes-extra-padding">
                <div class="bold-text">Наименование проекта </div>
                <div>{{projectName}}</div>
            </div>
            <div class="modal-grid-two-cols stripes-extra-padding">
                <div class="bold-text">Дата создания</div>
                <div>{{dateIntoRu(createDate)}}</div>
            </div>
            <div class="modal-grid-two-cols stripe stripes-extra-padding">
                <div class="bold-text">Последние изменениия </div>
                <div>{{dateIntoRu(lastUpdate)}}</div>
            </div>
            <div class="modal-grid-two-cols stripes-extra-padding">
                <div class="bold-text">Автор </div>
                <div class="ap-button-edit-category">
                    <div class="table-svg-button" v-on:click="selectUser">
                        <SVGAdminEditRow/>
                    </div>
                    <div>
                        {{user.fullname}}
                    </div>
                </div>
            </div>
            <div class="modal-grid-two-cols stripe stripes-extra-padding">
                <div class="bold-text">Заказчик </div>
                <div>{{customerName(customer.name)}}</div>
            </div>
            <div class="modal-grid-two-cols stripes-extra-padding">
                <div class="bold-text">Доступность в Lite версии </div>
                <div>
                    <div class="pretty p-default sidebar-checkbox">
                        <input type="checkbox" v-model="openRead"/>
                        <div class="state p-danger">
                            <label></label>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-grid-two-cols stripe stripes-extra-padding">
                <div class="bold-text">Включить доступ по ссылке </div>
                <div>
                    <div class="pretty p-default sidebar-checkbox">
                        <input type="checkbox" v-model="openWrite"/>
                        <div class="state p-danger">
                            <label></label>
                        </div>
                    </div>
                </div>
            </div>
<!--            <div class="modal-grid-two-cols stripes-extra-padding">-->
<!--                <div>Ссылка для редактирования: </div>-->
<!--                <div>-->
<!--                    <div v-on:click="confirmTransition(projectData)" style="cursor: pointer;">-->
<!--                        Перейти-->
<!--                        <SVGLink style="position: relative; top: 2px"/>-->
<!--                    </div>-->
<!--                </div>-->
<!--            </div>-->
        </div>
        <img style="display: block; margin: 5px auto; max-width: 95%; max-height: 270px;"
             :src="urlForPhoto(getFirstImg())"/>
        <div class="ap-projects-modal-btn-grid">
            <div class="modal-button" v-on:click="apply">
                Сохранить
            </div>
            <div v-on:click="confirmTransition(projectData)" class="modal-button">
                Редактировать проект
<!--                <SVGLink style="position: relative; top: 2px"/>-->
            </div>
        </div>
    </div>
</template>

<script>
import SVGLink from "../../../SVG/SVGLink";
import ModalConfirmation from "../../ModalConfirmation";
import SVGAdminEditRow from "../../../SVG/SVGAdminEditRow";
import ModalSelectUser from "../ModalSelectUser";
import {http_request} from "../../../../httpConfig";

export default {
name: "DataEntryFieldProject",
    components: {
        SVGAdminEditRow,
        SVGLink
    },
    props: {
        projectData: {
            type: Object,
            default() {
                return {};
            }
        }
    },
    data() {
        return {
            guidProject: '',
            projectName: '',
            createDate: '',
            lastUpdate: '',
            user: {},
            customer: {},
            openRead: false,
            openWrite: false
        }
    },
    methods: {
    callbackSelectUser(){
      return async (selectUserID) => {
          this.user = {};
          this.user = await http_request.post('/get_users', {id: selectUserID})
              .then((request) => {
                  console.log(request.data);
                  return request.data.user;
              })
              .catch((error) => {
                  context.state.allUploaded = true;
                  console.error(error);
              });
      }
    },
        selectUser(guid) {
            this.$modal.show(ModalSelectUser, {
                callback: this.callbackSelectUser()
            }, {
                name: 'selectUser',
                height: 'auto',
                pivotY: 0.2,
                width: 460,
                draggable: true,
            });
        },
        dateIntoRu(createDate) {
            let date = new Date(createDate).toLocaleString('ru', {
                year: 'numeric',
                month: 'long',
                day: 'numeric'
            });
            return date;
        },
        apply() {
            let dataForSend = {
                guid: this.guidProject,
                open_read: this.openRead,
                open_write: this.openWrite
            };
            if (this.user.id)
                dataForSend.user_id = this.user.id;
            this.$emit('apply', dataForSend);
        },
        getFirstImg() {
            if (!this.projectData.data_json)
                return '';

            const photoList = this.projectData.data_json.photoList;
            if(!photoList || Object.keys(photoList).length === 0)
                return '';

            return photoList[Object.keys(photoList)[0]].src;
        },
        urlForPhoto(url) {
            return this.$store.getters[`projectConfiguration/GENERATE_URL`](url);
        },
        customerName(name) {
            if (name) {
                return name
            } else {
                return 'Нет заказчика'
            }
        },
        goEditProject(projectGuid) {
            return () => {
                let route = this.$router.resolve({name: "loadPhoto", params: {projectUUID: projectGuid}});
                window.open(route.href, '_blank');
            }
        },
        confirmTransition(project) {
            const title = `Перейти к проекту "${project.data_json.name}"?`
            const text = 'Для редактирования проекта вы будете перемещены на страницу конфигуратора, хотите продолжить?';
            this.$modal.show(ModalConfirmation, {title, text, alright: this.goEditProject(project.guid)}, {
                name: 'confirmationModal',
                height: 'auto',
                pivotY: 0.2,
                width: 460,
                draggable: true,
            });
        },
    },
    mounted() {
        if (Object.keys(this.projectData).length !== 0) {
            this.guidProject = this.projectData.guid;
            this.projectName = this.projectData.data_json.name;
            this.createDate = this.projectData.create_date;
            this.lastUpdate = this.projectData.update_date;
            this.openRead = this.projectData.open_read;
            this.openWrite = this.projectData.open_write;
            if (this.projectData.users[0])
                this.user = this.projectData.users[0];
            if (this.projectData.customers[0])
                this.customer = this.projectData.customers[0];
        }
    }
}
</script>

<style scoped>
    .stripes-extra-padding {
        padding: 10px;
    }

    .ap-projects-modal-btn-grid {
        display: grid;
        grid-template-columns: 50% 50%;
        width: 521px;
    }
</style>
